import styled from 'styled-components';
import Modal from '@atresmedia/intranet-modal';

const StyledModalError = styled(Modal)`
  button[role='button'] {
    background-color: ${props => props.theme.colors.main};
    border-color: ${props => props.theme.colors.main};
    color: ${props => props.theme.colors.light};

    &:hover {
      background-color: ${props => props.theme.colors.grayDarker};
      border-color: ${props => props.theme.colors.grayDarker};
    }
  }
`;

export default StyledModalError;
